import { EstateResultItem_PropertyReportInput } from 'queries';

import Asset from './asset';

type Props = {
  id: string;
  showAssetBtn: boolean;
  property: EstateResultItem_PropertyReportInput;
  assignButton?: React.ReactNode;
  title: string;
  subtitle: string;
};

export default function PropertyAsset({
  id,
  showAssetBtn,
  property,
  assignButton,
  title,
  subtitle,
}: Props) {
  return (
    <Asset
      key={id}
      id={id}
      showAssetBtn={showAssetBtn}
      assignButton={assignButton}
      itemData={[
        { field: 'Name on Deed', value: property.nameOnDeed },
        { field: 'Parcel Number', value: property.parcelNumber },
        { field: 'Property Type', value: property.propertyType },
        { field: 'Transaction Type', value: property.transactionType },
        { field: 'Price on Transaction', value: property.priceOnTransaction },
      ]}
      title={title}
      subtitle={subtitle}
    />
  );
}
